export default "/images/following.png?aed6b6e7b74c9288ea5e933d6656700b";